// Conditionally initialize entry points based on different environments here:
// (e.g. Standalone app, Fabric, etc.)

await import('./index.web');

export {}; // Ensure this is treated as a module
